import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Pipeline from "@/pages/Pipeline";
import BDTracker from "@/pages/BDTracker";
import Leads from "@/pages/Leads";
import Properties from "@/pages/Properties";
import Consultants from "@/pages/Consultants";
import Owners from "@/pages/Owners";
import Intelligence from "@/pages/Intelligence";
import Team from "@/pages/Team";
import Settings from "@/pages/Settings";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F9FAFB]">
        <div className="h-8 w-8 rounded-full border-2 border-[#0047FF] border-t-transparent animate-spin" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AdminOnly({ children }) {
  const { user } = useAuth();
  if (user && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Protected><Layout /></Protected>}>
              <Route index element={<Dashboard />} />
              <Route path="pipeline" element={<Pipeline />} />
              <Route path="bd-tracker" element={<BDTracker />} />
              <Route path="leads" element={<Leads />} />
              <Route path="properties" element={<Properties />} />
              <Route path="consultants" element={<Consultants />} />
              <Route path="owners" element={<Owners />} />
              <Route path="intelligence" element={<Intelligence />} />
              <Route path="team" element={<AdminOnly><Team /></AdminOnly>} />
              <Route path="settings" element={<AdminOnly><Settings /></AdminOnly>} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
